<template>
  <div class="campaign-card">
    <div class="header" :class="{ 'not-activated': !assessment.activated }">
      <div v-if="!assessment.activated" class="not-activated-content">
        <div class="tag black">
          <i class="bi bi-info-circle" />
          Vous allez bientôt pouvoir jouer !
        </div>
        <p>
          Vous avez rejoint cette campagne avec succès. L’organisation à l’origine
          de cette évaluation doit désormais valider votre participation pour
          que vous puissiez lancer votre session de jeu.
        </p>
      </div>
      <img
        :src="
          assessment.campaign.image_id
            ? getImage(assessment.campaign.image_id)
            : getRandomCampaignPicture(assessment.campaign.public_name)
        "
        alt="Campaign header"
        ref="image"
      />
    </div>
    <div class="body">
      <div class="name-duration-row">
        <div class="block">
          <h4 class="card-title" v-text="assessment.campaign.public_name" />
          <p class="job" v-text="assessment.campaign.job_title" />
        </div>
        <div class="informations-container">
          <div class="tag-container">
            <div class="tag" :style="getThemeStyle(assessment.campaign)">TEMPS MOYEN: {{duration}} MIN</div>
          </div>
        </div>
      </div>
      <p class="campaign-description" v-html="assessment.campaign.job_description" />
      <Button
        v-if="!candidateStore.candidate.phone_verified && assessment.activated"
        class="icon icon-left primary full-size"
        :style="getThemeStyle(assessment.campaign)"
        label="Finaliser mon inscription pour jouer"
        icon="bi-shield-lock"
        @click="emits('verifyPhone')"
      />
      <Button
        v-else-if="assessment.state !== 2"
        class="icon icon-left primary full-size"
        :style="getThemeStyle(assessment.campaign)"
        :disabled="!canStart || !assessment.activated || isMobile"
        :label="btnLabel"
        :icon="assessment.state ? 'bi-rocket-takeoff' : 'bi-play-fill'"
        @click="emits('startAssessment')"
      />
      <Button
        v-else
        class="icon icon-left green full-size"
        icon="bi-clipboard-check"
        :label="
          hasResults
            ? 'Consulter vos résultats'
            : 'Résultats en attente de calcul'
        "
        :disabled="!hasResults"
        @click="goResults(assessment.campaign)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { getImage, getRandomCampaignPicture } from "@/composables/getImage.js";
import { useCandidateStore } from "@/stores/candidate.js";

const router = useRouter();

const emits = defineEmits(["verifyPhone", "startAssessment", "setBGImage"]);

const candidateStore = useCandidateStore();

const props = defineProps({
  assessment: {
    type: Object,
    required: true,
  },
  hasResults: {
    type: Boolean,
    required: true,
  },
  canStart: {
    type: Boolean,
    required: true,
  },
  isMobile: {
    type: Boolean,
    required: true,
  },
});

const btnLabel = computed(() => {
  if (props.isMobile)
    return "Connectez-vous depuis un ordinateur afin de lancer la session";

  if (props.assessment.state === 1) return "Reprendre mon évaluation";

  return "Démarrez votre évaluation maintenant !";
});

function getThemeStyle (campaign) {
  if(!campaign) {
    return '';
  }

  var bgColour = "#f2cb36";
  var textColour = "#000000";

  return {
  'background-color': campaign.elem_colour ? campaign.elem_colour : bgColour,
  'color': campaign.text_colour ? campaign.text_colour : textColour,
  };
}

function goResults (campaign) {
  if(campaign.version == 2) {
    router.push({ name: 'game-results-v2' })
  }
  else {
    router.push({ name: 'game-results' })
  }
}

const duration = computed<number>(() => {
  const version = getVersionObjectFromVersionID(props.assessment.campaign.calibration_id);
  if (version) return version.duration;
  return 50;
});

</script>
